import React from "react";
import { Layout, Row, Col, Typography } from "antd";
import {
  MailOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  FacebookOutlined,
  GlobalOutlined,
  HeartOutlined,
  ArrowRightOutlined
} from "@ant-design/icons";
import OpolBrandingLogo from "../assets/Opol_Branding_Logo.png";
import "./Footer.css";

const { Footer: AntFooter } = Layout;
const { Text, Title, Link } = Typography;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <AntFooter className="auth-footer">
      <div className="auth-footer-container">
        <Row gutter={[42, 32]} align="top">
          <Col xs={24} md={24} lg={8}>
            <div className="auth-footer-brand-panel">
            

              <Text className="auth-brand-label">MUNICIPAL ECONOMIC ENTERPRISE OFFICE</Text>

              <div className="auth-brand-title-wrap">
                <Title level={3} className="auth-footer-title">
                  MEEO System
                </Title>
              </div>

              <Text className="auth-footer-description">
                A modern public service platform focused on transparent, efficient, and community-centered enterprise support.
              </Text>
            </div>
          </Col>

          <Col xs={24} md={24} lg={8}>
            <Title level={5} className="auth-footer-heading">
              Contact Information
            </Title>

            <div className="auth-footer-contact">
              <div className="auth-contact-item">
                <EnvironmentOutlined className="auth-contact-icon" />
                <div>
                  <Text className="auth-contact-text">Municipal Economic Enterprise Office</Text>
                  <Text className="auth-contact-subtext">2nd Floor, Opol Public Market, Zone 4, Taboc, Opol, Misamis Oriental</Text>
                </div>
              </div>

              <div className="auth-contact-item">
                <PhoneOutlined className="auth-contact-icon" />
                <div>
                  <Link href="tel:09525663771" className="auth-contact-link">
                    0952 566 3771
                  </Link>
                  <Text className="auth-contact-subtext">Mon-Fri: 8:00 AM - 5:00 PM</Text>
                </div>
              </div>

              <div className="auth-contact-item">
                <MailOutlined className="auth-contact-icon" />
                <div>
                  <Link href="mailto:lguopolmeeo@gmail.com" className="auth-contact-link">
                    lguopolmeeo@gmail.com
                  </Link>
                  <Text className="auth-contact-subtext">24/7 Support Available</Text>
                </div>
              </div>
            </div>
          </Col>

          <Col xs={24} md={24} lg={8}>
            <div className="auth-connect-panel">
              <Title level={5} className="auth-footer-heading">
                Connect With Us
              </Title>

              <div className="auth-facebook-card">
                <div className="auth-facebook-badge">
                  <FacebookOutlined className="auth-facebook-icon" />
                </div>

                <div className="auth-facebook-content">
                  <Text className="auth-facebook-title">MEEO Opol Facebook</Text>
                  <Text className="auth-facebook-description">
                    Follow us for updates, announcements, and community news.
                  </Text>

                  <Link
                    href="https://www.facebook.com/profile.php?id=61560479091650"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="auth-facebook-link"
                  >
                    Visit Our Page
                    <ArrowRightOutlined className="auth-facebook-arrow" />
                  </Link>
                </div>
              </div>

              <div className="auth-opol-logo-wrap">
                <img
                  src={OpolBrandingLogo}
                  alt="OPOL branding logo"
                  className="auth-opol-logo"
                />
              </div>
            </div>
          </Col>
        </Row>

        <div className="auth-footer-bottom">
          <div className="auth-footer-branding">
            <GlobalOutlined />
            <Text className="auth-copyright-text">
              © {currentYear} MEEO System. All rights reserved.
            </Text>
          </div>

          <div className="auth-footer-credits">
            <Text className="auth-credits-text">
              <HeartOutlined className="auth-heart-icon" /> Developed by{" "}
              <Link href="https://www.facebook.com/ronnie1016" target="_blank" rel="noreferrer" className="auth-developer-link">
                Ronnie Flores
              </Link>
              {", "}
              <Link href="https://www.facebook.com/izheykhedoq420" target="_blank" rel="noreferrer" className="auth-developer-link">
                Jon Brey Lastimosa
              </Link>
              {", "}
              <Link href="https://www.facebook.com/tantanaba23/" target="_blank" rel="noreferrer" className="auth-developer-link">
                Nathaniel Aba
              </Link>
              {", "}
              <Link href="https://www.facebook.com/dean.franncis.quimanhan" target="_blank" rel="noreferrer" className="auth-developer-link">
                Dean Francis Quimanhan
              </Link>
              {" & Special thanks to "}
              <Link href="https://www.facebook.com/rowin.ranque.25" target="_blank" rel="noreferrer" className="auth-developer-link">
                Rowin Ranque
              </Link>
            </Text>
          </div>
        </div>
      </div>
    </AntFooter>
  );
};

export default Footer;
